function Statistic() {
   return(
    <div>
        kjjbdsjvbdshjvb
    </div>
   ) 
}

export default Statistic;